var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateParcelSenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0901 5.19012H22.8601V3.85012H20.8701V2.62012H24.1001V5.20012L24.0901 5.19012Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8496 9.1001H24.0796V10.4101H22.8496V9.1001Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7197 32.6399H22.1697V33.8699H11.7197V32.6399Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5498 35.26H20.8598V36.49H19.5498V35.26Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.48 40.48H1.23V1.23H10.41V0H0V41.71H41.71V24.12H40.48V40.48Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3705 0V1.23H15.0205V3.26H3.23047V4.49H15.0205V16.89H26.7005V4.5H38.4905V3.27H26.7005V1.23H40.4805V22.16H41.7105V0H12.3705ZM16.2505 15.67V13.64H18.2405V12.41H16.2505V1.23H25.4605V12.4H20.2005V13.63H25.4605V15.66H16.2505V15.67Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8496 6.48999H24.0796V7.79999H22.8496V6.48999Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.91992 31.3401V37.8001H10.3799V31.3401H3.91992ZM9.13992 36.5601H5.14992V32.5701H9.13992V36.5601Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7197 35.26H15.6397V36.49H11.7197V35.26Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9404 35.26H18.2504V36.49H16.9404V35.26Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1797 37.21H38.4897V38.44H37.1797V37.21Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1797 34.6001H38.4897V35.8301H37.1797V34.6001Z",
    fill: "#010101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5703 37.21H35.8803V38.44H34.5703V37.21Z",
    fill: "#010101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1022"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.71,
    height: 41.71,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateParcelSenderIcon);
export default __webpack_public_path__ + "static/media/private-parcel-sender-icon.e10bd80d5ea2f4222eda5505d3fc1ddf.svg";
export { ForwardRef as ReactComponent };